import * as sharedState from '@dtna/dvs-support-dcp-shared-state/lib/';

export const store = window.sharedStore;

export const {
  sharedContext: context,
  useHostDispatch,
  useHostSelector,
} = sharedState;
